import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-84">
      <div className="mx-auto max-w-3xl px-4" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-6 text-center" data-id="element-86">
          <h2 className="font-display text-3xl font-700 leading-tight text-ink sm:text-4xl" data-id="element-87">
            No Digas «Sí». Solo Decí «Tal Vez» Y Probalo Sin Ningún Riesgo Por
            30 Días
          </h2>
        </motion.div>

        <div className="space-y-4 text-lg leading-relaxed text-gray-800" data-id="element-88">
          <p data-id="element-89">
            Odio ver la palabra «garantía» pegada en todos lados. ¿Qué significa
            en realidad? Solo palabras. Frases hechas para que compres.
          </p>
          <p data-id="element-90">
            Por eso no te hago solo una garantía. Te hago una{' '}
            <strong className="font-700" data-id="element-91">promesa personal</strong>.
          </p>
          <p data-id="element-92">
            Creo, de verdad, que este es el sistema más completo para montar y
            hacer rentable una pollería que existe hoy en la Argentina. Se me
            caería el alma al piso si sintieras que te decepcionó. Así que este
            es el trato:
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-8 flex flex-col items-center gap-5 rounded-3xl border-4 border-green-600 bg-white p-8 text-center shadow-xl sm:flex-row sm:text-left" data-id="element-93">
          <ShieldCheckIcon className="h-24 w-24 shrink-0 text-green-600" aria-hidden="true" data-id="element-94" />
          <div data-id="element-95">
            <h3 className="mb-2 font-display text-2xl font-700 text-ink" data-id="element-96">
              Mi Garantía de 30 Días: «Ámalo O Dejalo»
            </h3>
            <p className="text-base leading-relaxed text-gray-700" data-id="element-97">
              Si esto no es el recurso más completo que viste jamás para tu
              pollería, escribime y te devuelvo el{' '}
              <strong className="font-700" data-id="element-98">100% de tu plata</strong>. Sin
              preguntas. Esta es mi garantía de hierro de 30 días completos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}